import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateCustomerGroupSettings } from '../../../../common/api/clients/company.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useCustomerGroupSettingsUpdate = (customerGroupId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateCustomerGroupSettings,
        onSuccess: () => {
            return queryClient.invalidateQueries({
                queryKey: queries.customerGroups.detail(customerGroupId)._ctx.settings.queryKey,
            });
        },
    });
};
